import React from "react"
import { Container, Row, Col } from "reactstrap"

import YandexMap from "../yandex-map"
import { PHONE, EMAIL } from "../../utils/constants"

import Animate from "../animate"

const ContactsSection = ({ title }) => {
  return (
    <section className="section section_contacts" id="contacts">
      <Container>
        <h2 className="section_title">{title}</h2>

        <div className="list list--bordered">
          <Row>
            <Col xs={12} md={4}>
              <Animate className="slide-up delay-1">
                <div className="list_item">
                  <div className="list_item__icon">
                    <i className="icon icon--phone" />
                  </div>
                  <div className="list_item__content">
                    <h5>Телефон</h5>
                    <a href={`tel:${PHONE}`} className="list_item__info">
                      {PHONE}
                    </a>
                  </div>
                </div>
              </Animate>
            </Col>
            <Col xs={12} md={4}>
              <Animate className="slide-up delay-2">
                <div className="list_item">
                  <div className="list_item__icon">
                    <i className="icon icon--mail" />
                  </div>
                  <div className="list_item__content">
                    <h5>Email</h5>
                    <a href={`mailto:${EMAIL}`} className="list_item__info">
                      {EMAIL}
                    </a>
                  </div>
                </div>
              </Animate>
            </Col>
            <Col xs={12} md={4} className="d-none d-md-block">
              <Animate className="slide-up delay-3">
                <div className="list_item">
                  <div className="list_item__icon" />
                  <div className="list_item__content">
                    <h5>Факс</h5>
                    <a href={`tel:${PHONE}`} className="list_item__info">
                      {PHONE}
                    </a>
                  </div>
                </div>
              </Animate>
            </Col>
          </Row>
        </div>

        <div className="section_contacts__group">
          <Row className="flex-md-row-reverse">
            <Col xs={12}>
              <Animate className="slide-right delay-3">
                <div className="map">
                  <YandexMap />
                </div>
              </Animate>
            </Col>
          </Row>
        </div>

        <div className="list list--bordered">
          <Row>
            <Col xs={12} md={4}>
              <Animate className="slide-up delay-3">
                <div className="list_item">
                  <div className="list_item__icon">
                    <i className="icon icon--pin" />
                  </div>
                  <div className="list_item__content">
                    <h5>Адрес</h5>
                    <div className="list_item__info">
                      15191, г. Москва, Гамсоновский переулок, д. 2. стр. 1,
                      <br />
                      бизнес-центр “T”, офис 204
                    </div>
                  </div>
                </div>
              </Animate>
            </Col>
            <Col xs={12} md={4}>
              <Animate className="slide-up delay-4">
                <div className="list_item">
                  <div className="list_item__icon">
                    <i className="icon icon--clock" />
                  </div>
                  <div className="list_item__content">
                    <h5>Время работы</h5>
                    <div className="list_item__info">
                      с 9:00 до 19:00, <br />с понедельника <br />
                      по пятницу
                    </div>
                  </div>
                </div>
              </Animate>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default ContactsSection
